module.exports = __webpack_public_path__ + "img/LUB00406.b0c17b8a.png";